module.exports = __webpack_public_path__ + "media/images/konintodoke/banner/banner_q-and-a-815cec1b2e53d42353144d1b19fc554f.png";